/**
 * Calendar Service - Irrigo Platform
 * Servicio para gestión de calendario de riegos
 */

import { api, ApiResponse } from './api';
import type { 
  ApiCalendarResponse,
  CalendarQueryParams,
} from '@/types/api';

// ============================================================================
// CALENDAR SERVICE
// ============================================================================

export const calendarService = {
  /**
   * Obtener eventos del calendario
   * @param params - Parámetros de consulta (view, date, filters)
   */
  async getEvents(params?: CalendarQueryParams): Promise<ApiResponse<ApiCalendarResponse>> {
    return api.get<ApiCalendarResponse>('/calendar', params);
  },

  /**
   * Obtener eventos para el día actual
   */
  async getToday(): Promise<ApiResponse<ApiCalendarResponse>> {
    return api.get<ApiCalendarResponse>('/calendar', { view: 'day' });
  },

  /**
   * Obtener eventos para la semana actual
   */
  async getThisWeek(): Promise<ApiResponse<ApiCalendarResponse>> {
    return api.get<ApiCalendarResponse>('/calendar', { view: 'week' });
  },

  /**
   * Obtener eventos para el mes actual
   */
  async getThisMonth(): Promise<ApiResponse<ApiCalendarResponse>> {
    return api.get<ApiCalendarResponse>('/calendar', { view: 'month' });
  },

  /**
   * Obtener eventos para un jardín específico
   */
  async getByGarden(gardenId: string, view: 'day' | 'week' | 'month' = 'week'): Promise<ApiResponse<ApiCalendarResponse>> {
    return api.get<ApiCalendarResponse>('/calendar', { view, gardenIds: gardenId });
  },

  /**
   * Obtener eventos próximos para hoy (para widget del dashboard)
   */
  async getUpcomingToday(): Promise<ApiResponse<ApiCalendarResponse>> {
    return api.get<ApiCalendarResponse>('/calendar', { view: 'day' });
  },
};

export default calendarService;
